export const TOPIC = 'topic';
export const VIDEO = 'video';
export const DETAILS = 'details';
export const PODCAST = 'podcast';



// WEBPACK FOOTER //
// ./src/constants/topicTabs.js